
import constant from "../../../../../constants/constant"
import { ProductTypeDropdownProps, ProductTypeProps } from "../interface"

export const getProductTypeDropdown = (response: []):ProductTypeProps[] => {
    let dropdown: ProductTypeDropdownProps[] = []
    response && response?.map((value: any) => {
        if(value?.name.toLowerCase() === constant.PRODUCT_FILTER_TYPE.SUN_GLASSES || value?.name.toLowerCase() === constant.PRODUCT_FILTER_TYPE.EYE_GLASSES){
            dropdown.push({
                "value": value.id,
                "label": value.name,
                "code":  value?.product_type?.product_type_initials
            }
            )
        }
    })
    return dropdown
}